import React from 'react';
import { Grid, Container } from '@material-ui/core';
import styles from './style.module.scss';
import DefaultContainer from '../DefaultContainer';
import HeadlineSmall from '../HeadlineSmall';
import HeadlineLarge from '../HeadlineLarge';
import ImageContainer from '../ImageContainer';
import CaseCard from '../../templates/CaseCard';
import SpecialCaseCard from '../SpecialCaseCard';

import cases from '../../data/casesThumb';

const CasesSection = () => (
  <DefaultContainer
    justify="flex-start"
    direction="column"
    className={styles.container}
    noPadding
  >
    <Container>
      <Grid item>
        <HeadlineSmall>Cases</HeadlineSmall>
        <HeadlineLarge
          medium
          stroke="work"
          className={styles.headlineLarge}
        >
          Recent
        </HeadlineLarge>
      </Grid>
    </Container>
    <ImageContainer>
      {
        cases.map(item => (!item.path.includes('weapplead') ? (
          <Grid item xs={12} md={6} key={item.path}>
            <CaseCard
              color={item.color}
              caseBg={item.casebg}
              caseImg={item.case}
              caseImgLeftAlign={item.caseImgLeftAlign}
              caseImgRightAlign={item.caseImgRightAlign}
              title={item.title}
              titleSmall={item.headline}
              description={item.description}
              path={item.path}
              isWeb={item.isWeb}
              isAndroid={item.isAndroid}
              textColor={item.textColor}
            />
          </Grid>
        ) : (
          <Grid item xs={12} md={6} key={item.path}>
            <SpecialCaseCard item={item} />
          </Grid>
        )))
      }
    </ImageContainer>
  </DefaultContainer>
);

export default CasesSection;
